import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';


@Component
export class StickyAddToCart extends ThemeComponent {
    @Ref() observer!: Element;
    @Ref() stickyElement!: HTMLDivElement;
    @Ref() stickyAddButton!: HTMLButtonElement;

    private _onAddToCart = new SimpleEvent<boolean | null>();

    public get onAddToCart() {
        return this._onAddToCart.asEvent();
    }

    init() {
        this.stickyAddToCart();

        this.$listen(this.stickyAddButton, 'click', () => {
            this.addToCart();
        });
    }

    stickyAddToCart() {
        const stickyElem = this.stickyElement as HTMLDivElement;

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].boundingClientRect.y < 0) {
                stickyElem.classList.add('is-active');
            } else {
                stickyElem.classList.remove('is-active');
            }
        }, { threshold: 0.8 });

        observer.observe(this.observer);
    }

    addToCart() {
        const submitButton = document.querySelector('[data-ref="submitButton"]') as HTMLButtonElement;

        if (!submitButton) { return; }
        submitButton.click();
    }
}
